import { args } from '../common/args';
import { Tags } from '../config/constants';
import { defineCapability } from './internal';
export const HIDE_COMPONENT_CAP = defineCapability({
  name: 'HIDE_COMPONENT_CAP',
  args: {
    byTag: args.optional(args.or(...Object.values(Tags).map(tag => args.literal(tag)))),
    byName: args.optional(args.string())
  }
});